import React from 'react'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useDispatch } from 'react-redux'
import { subscriptionActions } from '../actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'

function InetumPricing(props) {
  const dispatch = useDispatch()
  const handleChoosePlan = () => {
    const orgId = getCurrentOrgId()
    dispatch(subscriptionActions.redirectToSubscriptionCheckout(orgId, 'inetum'))
  }
  return (
    <PageContainer pageTitle={`Pricing for inetum`} pageClassName={styles.mainPage} withFooter={false}>
      <Button text='Proceed to billing' handleClick={handleChoosePlan} />
    </PageContainer>
  )
}

export default InetumPricing
